import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "table align-middle table-row-dashed fs-6 gy-3 table-hover" }
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Generated", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["onClick"]

import { ref, onMounted } from "vue";
import ReportService from "../services/ReportService";
import { Select, CloseBold, Clock } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";
import ConfirmationDetail from "../components/clientConfirmation/ConfirmationDetail.vue";
import SendConfirmation from "../components/clientConfirmation/SendConfirmation.vue";
import {
  AccountReportStatusTypes,
  AccountReportStatusOptions,
} from "@/core/types/AccountReportStatusTypes";
import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  __name: 'ClientConfirmation',
  setup(__props) {

const data = ref(Array<any>());
const viewDetailModalRef = ref<any>(null);
const sendConfirmationModalRef = ref<any>(null);
const isLoading = ref(false);
const userSelected = ref(0);
const selectedDate = ref(moment().format("YYYY-MM-DD"));
const criteria = ref({
  page: 1,
  pageSize: 20,
  date: "",
});
// console.log(moment().format("YYYY-MM-DD") + "T00:00:00.000Z")
const tagUser = (item: any) => {
  userSelected.value = item.id;
};

const changePage = (page: number) => {
  fetchData(page);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  criteria.value.date =
    moment(selectedDate.value).format("YYYY-MM-DD") + "T00:00:00.000Z";
  try {
    const res = await ReportService.queryAccountReport(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const viewDetail = (item: any) => {
  viewDetailModalRef.value?.show(item);
};

const reset = async () => {
  selectedDate.value = moment().format("YYYY-MM-DD");
  criteria.value = {
    page: 1,
    pageSize: 20,
    date: moment().format("YYYY-MM-DD") + "T00:00:00.000Z",
  };
  fetchData(1);
};

const send = async (item: any) => {
  sendConfirmationModalRef.value?.show(item);
};

const download = async (item: any) => {
  try {
    // const res = await ReportService.downloadClientConfirmation(item.id);
    ElNotification({
      title: "Success",
      message: "Download successfully",
      type: "success",
    });
  } catch (error) {
    ElNotification({
      title: "Error",
      message: "Download failed",
      type: "error",
    });
  }
};

const regenerate = async (item: any) => {
  try {
    // const res = await ReportService.regenerateClientConfirmation(item.id);
    ElNotification({
      title: "Success",
      message: "Regenerate successfully",
      type: "success",
    });
  } catch (error) {
    ElNotification({
      title: "Error",
      message: "Regenerate failed",
      type: "error",
    });
  }
};
onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_date_picker, {
            modelValue: selectedDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event)),
            placeholder: "Pick a day"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_input, {
            modelValue: criteria.value.AccountNumber,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.AccountNumber) = $event)),
            placeholder: "Account Number",
            class: "mx-4",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            modelValue: criteria.value.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.status) = $event)),
            placeholder: "Status",
            class: "mx-4",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AccountReportStatusOptions), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (fetchData(1))),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: reset,
            type: "info",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.date")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _hoisted_7,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.email")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({
              'user-select': item.id === userSelected.value,
            }),
                      onClick: ($event: any) => (tagUser(item))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "reportDate",
                          "date-iso-string": item.date
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                      _createElementVNode("td", null, [
                        (item.status >= 10)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              size: "17",
                              color: "#67c23a"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Select))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              size: "17",
                              color: "#979b95"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Clock))
                              ]),
                              _: 1
                            }))
                      ]),
                      _createElementVNode("td", null, [
                        (item.status > 10)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              size: "17",
                              color: "#67c23a"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Select))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              size: "17",
                              color: "#979b95"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Clock))
                              ]),
                              _: 1
                            }))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "reportTime",
                          "date-iso-string": item.updatedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "reportTime",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          disabled: item.status < 10,
                          onClick: ($event: any) => (send(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.send")), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]),
                        _createVNode(_component_el_button, {
                          type: "warning",
                          size: "small",
                          disabled: item.status < 10,
                          onClick: ($event: any) => (viewDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ])
                    ], 10, _hoisted_11))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: changePage,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(ConfirmationDetail, {
      ref_key: "viewDetailModalRef",
      ref: viewDetailModalRef
    }, null, 512),
    _createVNode(SendConfirmation, {
      ref_key: "sendConfirmationModalRef",
      ref: sendConfirmationModalRef
    }, null, 512)
  ], 64))
}
}

})